import WorkbookInfoButton from './WorkbookInfoButton';
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Sidebar from "../../DesignSystem/Sidebar";
import Breadcrumb from "../../DesignSystem/Breadcrumb/Breadcrumb";
import { pensionCalculators } from "./access";
import { usePensionClient, ClientHeader } from "./Clients/ClientContext";
import { clientPath, dashboardPath } from "./Clients/clientApi";
import OutlinedStatusButton, {
  OUTLINED_STATUS_BUTTON_COLORS,
} from "../../DesignSystem/Buttons/OutlinedStatusButtons";
import {
  CalculatorStatusContext,
  calculatorStatuses,
} from "./calculatorStatus";
import "../../../css/DesignSystem/Cards/StatusCard.css";
import "../../../css/DesignSystem/Layout/ReferenceFormLayout.css";
import "../../../css/FinancialPromotions/FinancialPromotionsSubmission.css";
import "../../../css/FinancialPromotions/FinancialPromotions.css";
import "../../../css/FinancialPromotions/FPUI.css";

export default function PensionCalculatorPage({ calculator, children }) {
  const clientContext = usePensionClient();
  const navigate = useNavigate();
  const [currentStatus, setCurrentStatus] = useState(
    clientContext?.getDraft(calculator.id)?.status || "not-started",
  );
  return (
    <CalculatorStatusContext.Provider value={setCurrentStatus}>
      <div
        className="Main-Page"
        style={{
          height: "100vh",
          overflow: "hidden",
          background: "var(--Brand4-LavenderWeb)",
        }}
      >
        <Helmet>
          <title>{calculator.label} | Pension Calculators</title>
        </Helmet>
        <Sidebar isSetExpanded />
        <main
          className="Main-Container bg-lavender-web"
          style={{ minWidth: 0, height: "100vh", overflow: "hidden" }}
        >
          <div
            className="fp-submission-container"
            style={{
              height: "100%",
              minHeight: 0,
              overflow: "hidden",
              boxSizing: "border-box",
              background: "var(--Brand4-LavenderWeb)",
              gap: "var(--gap-m)",
            }}
          >
            <Breadcrumb
              showBackButton
              onBack={() => {
                if (!clientContext?.dirty || window.confirm('Leave this client without saving your changes?')) navigate(dashboardPath);
              }}
              items={[
                {
                  label: "Tools & Calculators",
                  to: "/portal/tools-calculators",
                },
                { label: "Pension Calculators", to: dashboardPath },
                {
                  label: clientContext?.client.profile.name || calculator.label,
                },
              ]}
            />
            <ClientHeader />
            <div
              className="row-wrap gap-m pension-calculator-panes"
              style={{
                flex: "1 1 0",
                minHeight: 0,
                alignItems: "stretch",
                flexWrap: "nowrap",
                overflow: "hidden",
              }}
            >
              <nav
                className="fit-column p-xs pension-calculator-menu"
                aria-label="Pension calculators"
                tabIndex={0}
                style={{
                  flex: "1 1 220px",
                  maxWidth: "100%",
                  minWidth: 0,
                  minHeight: 0,
                  height: "100%",
                  overflowY: "auto",
                  overflowX: "hidden",
                  overscrollBehavior: "contain",
                  paddingRight: "var(--FP_Gap_XS)",
                  boxSizing: "border-box",
                  scrollbarGutter: "stable",
                }}
              >
                <div
                  className="fit-column gap-m px-xxs"
                  style={{ flexShrink: 0, boxSizing: "border-box" }}
                >
                  {pensionCalculators.map((item) => {
                    const status =
                      calculatorStatuses[
                        item.id === calculator.id
                          ? currentStatus
                          : clientContext?.calculators[item.id]?.status ||
                            "not-started"
                      ];
                    const color = OUTLINED_STATUS_BUTTON_COLORS[status.color];
                    return (
                      <NavLink
                        key={item.id}
                        to={
                          clientContext
                            ? clientPath(
                                clientContext.client.id,
                                clientContext.client.ownerEmail,
                                item.id,
                              )
                            : `/portal/tools-calculators/${item.id}`
                        }
                        className={({ isActive }) =>
                          `reference-history-card bg-white corner${isActive ? " reference-history-card--active" : ""}`
                        }
                        style={{
                          flexShrink: 0,
                          minWidth: 0,
                          textDecoration: "none",
                          "--reference-card-status-color": color.border,
                        }}
                      >
                        <div
                          className="fit-column gap-s flex-1 p-s"
                          style={{ minWidth: 0, alignItems: "flex-start" }}
                        >
                          <span className="FP_Content_Semibold text-black">
                            {item.menuLabel || item.label}
                          </span>
                          <span className="FP_Help_Text_Semibold text-primary-1">
                            {item.description}
                          </span>
                          <OutlinedStatusButton
                            label={status.label}
                            color={status.color}
                            className="reference-history-card-status"
                          />
                        </div>
                      </NavLink>
                    );
                  })}
                </div>
              </nav>
              <section
                key={JSON.stringify(clientContext?.client.profile)}
                className="work-history-reference-form fit-column gap-l flex-1 bg-white p-m corner card-corner-radius pension-calculator-workspace"
                aria-label={calculator.label}
                tabIndex={0}
                style={{
                  flex: "4 1 560px",
                  minWidth: 0,
                  minHeight: 0,
                  height: "100%",
                  overflowY: "auto",
                  overflowX: "hidden",
                  overscrollBehavior: "contain",
                  boxSizing: "border-box",
                }}
              >
                <div className="row-space-between gap-m" style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
                  <h2 className="FP_Subtitle_Semibold text-primary-1" style={{ margin: 0, textAlign: "left", minWidth: 0 }}>
                    {calculator.menuLabel || calculator.label}
                  </h2>
                  <WorkbookInfoButton key={calculator.id} calculator={calculator} getResult={() => clientContext?.getDraft(calculator.id)?.result} />
                </div>
                {children}
              </section>
            </div>
          </div>
        </main>
      </div>
    </CalculatorStatusContext.Provider>
  );
}
